import Autosuggest from 'react-autosuggest';
import { compose, defaultProps, lifecycle, setPropTypes, withHandlers, withState } from 'recompose';
import PropTypes from 'prop-types';
import React from 'react';
import config from '../../../../../../config';

const search = (accounts, term) => {
  const account = accounts.find(acc => acc.name === term);

  return account !== undefined ? account : null;
};

const AccountSelector = compose(
  setPropTypes({
    accounts: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })).isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  }),
  defaultProps({
    value: '',
  }),
  withState('suggestions', 'setSuggestions', []),
  withState('inputProps', 'setInputProps', {
    value: '',
    onChange: () => {
    },
  }),
  withHandlers({
    onSuggestionsFetchRequested: props => ({ value }) => {
      const inputValue = value.trim().toLowerCase();
      const inputLength = inputValue.length;
      let result = inputLength === 0 ? [] : props.accounts.filter(account =>
        account.name.toLowerCase().indexOf(inputValue) > -1
      );

      if (value === '' && props.accounts.length <= 10) {
        result = [...props.accounts];
      }

      props.setSuggestions(result);
    },
    onSuggestionsClearRequested: props => () => {
      props.setSuggestions([]);
    },
    getSuggestionValue: () => suggestion => suggestion.name,
    // eslint-disable-next-line react/jsx-filename-extension
    renderSuggestion: () => suggestion => <span>{suggestion.name}</span>,
    shouldRenderSuggestions: props => value => props.accounts.length <= 10 || value.trim().length > 0,
    onSuggestionSelected: () => (event, { method }) => {
      if (method === 'enter') {
        event.preventDefault();
      }
    },
  }),
  lifecycle({
    componentWillMount() {
      const hasMoreThanTenAccounts = this.props.accounts.length > 10;
      this.props.setSuggestions(hasMoreThanTenAccounts ? [] : [...this.props.accounts]);
      const onChange = (event, { newValue }) => {
        this.props.setInputProps({
          ...this.props.inputProps,
          value: newValue || '',
        });
        const selectedAccount = search(this.props.accounts, newValue);
        if (selectedAccount || newValue === '') {
          this.props.onChange(selectedAccount);
        }
      };
      const onBlur = (event) => {
        const value = event.target.value;
        const selectedAccount = search(this.props.accounts, value);
        if (!selectedAccount) {
          this.props.setInputProps({
            ...this.props.inputProps,
            value: '',
          });
        }
        this.props.onChange(selectedAccount);
      };
      const account = this.props.accounts.find(acc => acc.id === this.props.value);
      this.props.setInputProps({
        value: account ? account.name : '',
        onChange: onChange.bind(this),
        onBlur: onBlur.bind(this),
        onKeyDown: () => (e) => {
          const keyCode = e.keyCode || e.charCode;
          if (keyCode === config.ENTER_KEY_CODE) {
            e.preventDefault();
          }
        },
        className: 'c-input',
        placeholder: hasMoreThanTenAccounts ? 'Start typing for account list...' : '',
      });
    },
  })
)(Autosuggest);

export default AccountSelector;
